import React from 'react';

interface PluginsTabProps {
  loading: boolean;
  pluginGroups: Map<string, string[]>;
  allPluginActions: string[];
  isEnabled: (action: string, subject: string | null) => boolean;
  togglePerm: (action: string, subject: string | null) => void;
  selectAllPlugins: () => void;
  deselectAllPlugins: () => void;
  isSystem?: boolean;
}

const PluginsTab: React.FC<PluginsTabProps> = ({
  loading,
  pluginGroups,
  allPluginActions,
  isEnabled,
  togglePerm,
  selectAllPlugins,
  deselectAllPlugins,
  isSystem,
}) => {
  return (
    <div className="border border-t-0 border-gray-200 rounded-b-lg">
      <div className="flex justify-end gap-2 p-3 bg-gray-50 border-b border-gray-200">
        <button type="button" onClick={selectAllPlugins} className="text-xs text-ocean-600 hover:text-ocean-800 font-medium" disabled={isSystem}>
          Select All
        </button>
        <span className="text-gray-300">|</span>
        <button type="button" onClick={deselectAllPlugins} className="text-xs text-red-600 hover:text-red-800 font-medium" disabled={isSystem}>
          Deselect All
        </button>
      </div>

      {loading && (
        <div className="p-8 text-center text-gray-500">Loading available permissions...</div>
      )}

      {!loading && allPluginActions.length === 0 && (
        <div className="p-8 text-center text-gray-500">No plugin permissions found.</div>
      )}

      <div className="max-h-[28rem] overflow-y-auto divide-y divide-gray-100">
        {Array.from(pluginGroups.entries()).map(([prefix, actions]) => (
          <div key={prefix} className="p-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-2">{prefix}</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
              {actions.sort().map(action => (
                <label key={action} className="flex items-center gap-2 p-1.5 rounded hover:bg-gray-50 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isEnabled(action, null)}
                    onChange={() => togglePerm(action, null)}
                    className="h-4 w-4 text-ocean-600 focus:ring-ocean-500 border-gray-300 rounded"
                    disabled={isSystem}
                  />
                  <span className="text-xs font-mono text-gray-700 truncate">
                    {action.replace(prefix + '.', '')}
                  </span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PluginsTab;
